/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CandidateType;

(function (CandidateType) {
  CandidateType["CANDIDATE"] = "candidate";
  CandidateType["SUPPLIER"] = "supplier";
})(CandidateType || (CandidateType = {}));